import { useTranslation } from "react-i18next";

/**
 * One warning per card rather than one under every switch on it: an alert with
 * no webhook behind it is configured and silent, which is the failure worth
 * naming once.
 */
export function SlackWarning() {
  const { t } = useTranslation();

  return (
    <div className="px-5 py-3">
      <p className="m-0 rounded-md border border-warning-border bg-warning-subtle px-3 py-2 text-xs text-warning-subtle-foreground">
        {t(
          "admin.opsSettings.noSlack",
          "No admin-alerts Slack webhook is configured, so this alert has nowhere to go until one is set.",
        )}
      </p>
    </div>
  );
}
